module.exports = __webpack_public_path__ + "img/process1.142bd693.svg";